/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable no-sequences */
/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import { withRouter } from 'react-router';

import Accordion from 'Components/Accordian';

import HeroImage from 'assets/images/placeholderImages/production-howItWork-crop-top.png';
import FirstTabImage from 'assets/images/placeholderImages/first_tab_howitwork.png';
import SecondTabImage from 'assets/images/placeholderImages/production-secondTab-howItWork.png';
import PrimeTag from 'Components/atoms/PrimeTag';

const ProductionHowItWorks: React.FC = () => {
  const [accordian, setAccordian] = useState<number>(1);

  return (
    <div>

      <section className="flex relative justify-between items-center">
        <img
          src={HeroImage}
          alt="how it work resource fashion"
          className="h-96 lg:h-screen w-screen object-cover "
        />
        <div className="absolute lg:w-3/4 pl-5 lg:pl-20">
          <h1 className="text-white text-4xl lg:text-6xl font-serif">
            Fashion production supply chain service
          </h1>
          <span className="bg-red-400 text-2xl px-1 mt-4">
            How it works
          </span>
        </div>
      </section>

      <section>

        <div onClick={() => setAccordian(1)}>
          <Accordion
            headingClass="py-5 px-5 font-semibold border-2 border-black"
            heading="Sign up & Onboarding"
            h1Class="text-2xl text-center mx-auto"
            preOpen={accordian === 1}
          >
            <div className="grid grid-cols-12 bg-seaGreen border-black border-b-2 border-l-2 border-r-2">
              <div className="col-span-12 md:col-span-6 lg:col-span-6">
                <img src={FirstTabImage} alt="Resourece Manufacturers 101" />
              </div>
              <div className="p-10 md:text-2xl font-medium font-serif col-span-12 md:col-span-6 lg:col-span-6 flex flex-col space-y-4">
                <p>
                  Signing up on our website is quick and easy. Every customer receives a 1-week free trial, and after that, the subscription is billed at $349 per month. You have the freedom to cancel or pause at any time with no strings attached.
                </p>
                <p>
                  If your bulk production value exceeds $50k in a quarter, we offer an exclusive opportunity. We will create your first samples at no cost and waive the subscription fee. To see if you qualify for this tier, schedule a call with us&nbsp;
                  <a style={{ 'color': 'blue' }} href='https://calendly.com/ziqi/30min?back=1&month=2023-05'>here</a>
                  .
                </p>
                <p>
                  As soon as you've signed up, schedule an onboarding call with our team. We'll guide you through our dashboard, ensuring you're equipped to get started right away.
                </p>
              </div>
            </div>
          </Accordion>
        </div>

        <div onClick={() => setAccordian(2)}>
          <Accordion
            headingClass="py-5 px-5 font-semibold border-l-2 border-r-2 border-black"
            heading="Onboarding call & access our platform"
            h1Class="text-2xl text-center mx-auto"
            preOpen={accordian === 2}
          >
            <div className="grid grid-cols-12 bg-seaGreen border-black border-t-2 border-l-2 border-r-2">
              <div className="col-span-12 md:col-span-6 lg:col-span-6 lg:order-2">
                <img src={SecondTabImage} alt="ORDER REVIEWS" />
              </div>
              <div className="p-10 md:text-2xl font-large font-serif col-span-12 md:col-span-6 lg:col-span-6 lg:order-1 flex flex-col space-y-4">
                <p>
                  During the onboarding call, we'll discuss your fashion aspirations and provide advice on setting up your supply chain. You'll receive a demo of our latest production management portal and app, enabling you to start sampling immediately. If you need to send a reference sample or fabric, we'll assist you in generating a discounted shipping label to drop off at a local mailing company. Check our dashboard&nbsp;
                  <a style={{ 'color': 'blue' }} href='https://www.youtube.com/watch?v=Z8TmqXiQZ0A&list=PLU_Ys1Y46WE_551bU5GbIlfDen6T4q5GG&index=8'>here</a>
                  .
                </p>
              </div>
            </div>
          </Accordion>
        </div>

        <div onClick={() => setAccordian(3)}>
          <Accordion
            headingClass="bg-sand py-5 px-5 font-semibold border-2 border-black"
            heading="Upload styles and start fabric sourcing"
            h1Class="text-2xl text-center mx-auto"
            preOpen={accordian === 3}
          >
            <div className="grid grid-cols-12 bg-seaGreen border-black border-b-2 border-l-2 border-r-2">
              <div className="col-span-12 md:col-span-6 lg:col-span-6">
                <img src={FirstTabImage} alt="Resourece Manufacturers 101" />
              </div>
              <div className="p-10 md:text-2xl font-large font-serif col-span-12 md:col-span-6 lg:col-span-6 lg:order-1 flex flex-col space-y-4">
                <p>
                  Easily upload the styles you want to work on directly through our platform. You can provide tech packs, sketches, or pictures. The more information and visuals you share, the faster we can ensure accuracy. Let us know your fabric preferences, and we'll begin searching for options right away. Typically, we'll get back to you within 2 days with fabric choices.
                </p>
              </div>
            </div>

          </Accordion>
        </div>

        <div onClick={() => setAccordian(4)}>
          <Accordion
            headingClass="py-5 px-5 font-semibold border-l-2 border-r-2 border-black"
            heading="Place sample orders and provide feedbacks"
            h1Class="text-2xl text-center mx-auto"
            preOpen={accordian === 4}
          >
            <div className="grid grid-cols-12 bg-seaGreen border-black border-t-2 border-l-2 border-r-2">
              <div className="col-span-12 md:col-span-6 lg:col-span-6 lg:order-2">
                <img src={SecondTabImage} alt="ORDER REVIEWS" />
              </div>
              <div className="p-10 md:text-2xl font-large font-serif col-span-12 md:col-span-6 lg:col-span-6 lg:order-1 flex flex-col space-y-4">
                <p>
                  Once we upload the fabric options, you'll receive an email notification to review and make sample selections. Specify the fabric and colors you prefer, and we'll promptly create your samples, typically within 7 days. We'll upload physical pictures of the samples and offer virtual fitting options.
                </p>
                <p>
                  You can request a shipment to receive your sample. Provide feedback on the samples, expressing your likes and dislikes, before proceeding to a second round of sample making, if needed. It usually takes 2-3 rounds of samples to reach the perfect pre-production stage. Once you're satisfied, request bulk quotes to transform your designs into sellable garments.
                </p>
              </div>
            </div>
          </Accordion>
        </div>

        <div onClick={() => setAccordian(5)}>
          <Accordion
            headingClass="bg-sand py-5 px-5 font-semibold border-2 border-black"
            heading="Bulk quotes & production"
            h1Class="text-2xl text-center mx-auto"
            preOpen={accordian === 5}
          >
            <div className="grid grid-cols-12 bg-seaGreen border-black border-b-2 border-l-2 border-r-2">
              <div className="col-span-12 md:col-span-6 lg:col-span-6">
                <img src={FirstTabImage} alt="Resourece Manufacturers 101" />
              </div>
              <div className="p-10 md:text-2xl font-large font-serif col-span-12 md:col-span-6 lg:col-span-6 lg:order-1 flex flex-col space-y-4">
                <p>
                  Experience a fully transparent quoting process, where you'll see a detailed breakdown of pricing. Trigger production by paying 50% upfront, with the remaining 50% due upon completion. Shipping fees must be settled before shipment. Bulk production typically takes around one month from the date of confirmation and initial payment.
                </p>
              </div>
            </div>

          </Accordion>
        </div>

        <div onClick={() => setAccordian(6)}>
          <Accordion
            headingClass="py-5 px-5 font-semibold border-l-2 border-r-2 border-black"
            heading="Receive Bulk"
            h1Class="text-2xl text-center mx-auto"
            preOpen={accordian === 6}
          >
            <div className="grid grid-cols-12 bg-seaGreen border-black border-t-2 border-l-2 border-r-2">
              <div className="col-span-12 md:col-span-6 lg:col-span-6 lg:order-2">
                <img src={SecondTabImage} alt="ORDER REVIEWS" />
              </div>
              <div className="p-10 md:text-2xl font-large font-serif col-span-12 md:col-span-6 lg:col-span-6 lg:order-1 flex flex-col space-y-4">
                <p>
                  Once bulk production is complete and passes our rigorous quality assurance process, we'll ship the products to you. All shipments are tracked, and you can easily access tracking info on our dashboard. Each package is clearly labeled, providing clarity on its contents and expected arrival. Air shipping takes approximately 7 days, while sea shipping averages 3 weeks. You have the option to use our freight forwarder partner with discounted rates or your preferred shipping method.
                </p>
                <p>
                  Embark on a seamless journey with us, exploring our personalized services and transparent processes. Together, we'll bring your fashion vision to life.
                </p>
              </div>
            </div>
          </Accordion>
        </div>

      </section>
    </div>
  );
};

export default withRouter(ProductionHowItWorks);
